// extracted by mini-css-extract-plugin
module.exports = {"cls1":"UserWorklistsPage-CssProp5_th-module--cls1--1ZkC6","cls2":"UserWorklistsPage-CssProp5_th-module--cls2--37oRI UserWorklistsPage-CssProp5_th-module--cls1--1ZkC6"};